
export const UpdateMeasurement_REQUEST = "UpdateMeasurement_REQUEST";
export const UpdateMeasurement_SUCCESS = "UpdateMeasurement_SUCCESS";
export const UpdateMeasurement_FAIL = "UpdateMeasurement_FAIL";


export const AddMeasurement_REQUEST = "AddMeasurement_REQUEST";
export const AddMeasurement_SUCCESS = "AddMeasurement_SUCCESS";
export const AddMeasurement_FAIL = "AddMeasurement_FAIL";


export const GetMeasurementsByCustomerId_REQUEST = "GetMeasurementsByCustomerId_REQUEST";
export const GetMeasurementsByCustomerId_SUCCESS = "GetMeasurementsByCustomerId_SUCCESS";
export const GetMeasurementsByCustomerId_FAIL = "GetMeasurementsByCustomerId_FAIL";

export const GetAllMeasurements_REQUEST = "GetAllMeasurements_REQUEST";
export const GetAllMeasurements_SUCCESS = "GetAllMeasurements_SUCCESS";
export const GetAllMeasurements_FAIL = "GetAllMeasurements_FAIL";

export const GetMeasurementByOrderId_REQUEST = "GetMeasurementByOrderId_REQUEST";
export const GetMeasurementByOrderId_SUCCESS = "GetMeasurementByOrderId_SUCCESS";
export const GetMeasurementByOrderId_FAIL = "GetMeasurementByOrderId_FAIL";